/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function updatePolicyContent() {
    if (!document.body.classList.contains('template-policy')) {
      return;
    }

    var policyBody = document.querySelector('.shopify-policy__body');

    if (!policyBody) {
      return;
    }

    var textWalker = document.createTreeWalker(policyBody, NodeFilter.SHOW_TEXT);
    var textNode;

    while ((textNode = textWalker.nextNode())) {
      textNode.nodeValue = textNode.nodeValue
        .replace(/Angaben gemäß §\s*5\s+TMG/gi, 'Angaben gemäß § 5 DDG')
        .replace(
          /Die Lieferkosten werden im Konfigurator automatisch berechnet\./gi,
          'Die Kosten für Lieferung und Montage werden passend zu Ihrem Auftrag individuell abgestimmt.'
        )
        .replace(
          /Kunden können ihre Postleitzahl eingeben[^.]*\./gi,
          'Die vereinbarten Kosten werden im persönlichen Angebot transparent ausgewiesen.'
        )
        .replace(
          /Die Versandkosten werden im Konfigurator oder kasse angezeigt und richten sich nach Größe, Gewicht und Lieferadresse\./gi,
          'Die Versandkosten für direkt kaufbare Standardprodukte richten sich nach Größe, Gewicht und Lieferadresse und werden im Checkout transparent angezeigt.'
        );
    }

    policyBody.querySelectorAll('h1').forEach(function (heading) {
      var replacement = document.createElement('h2');

      Array.prototype.slice.call(heading.attributes).forEach(function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });

      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });

    policyBody.querySelectorAll('h2, h3').forEach(function (heading) {
      if (/^Online-Streitbeilegung$/i.test(normalizeText(heading.textContent))) {
        heading.textContent = 'Verbraucherstreitbeilegung';
      }
    });

    policyBody.querySelectorAll('p, li').forEach(function (element) {
      var text = normalizeText(element.textContent);
      var hasOldPlatformText = /Europäische Kommission.*Plattform.*Online-Streitbeilegung/i.test(text);
      var hasOldPlatformUrl = /ec\.europa\.eu\/consumers\/odr/i.test(text) || element.querySelector('a[href*="ec.europa.eu/consumers/odr"]');

      if (hasOldPlatformText || hasOldPlatformUrl) {
        element.remove();
      }
    });
  }

  function updateVisibleCopy() {
    var contentRoot = document.querySelector('main');

    if (!contentRoot) {
      return;
    }

    var textWalker = document.createTreeWalker(contentRoot, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;

        if (!parent || parent.closest('script, style, noscript, textarea')) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNode;

    while ((textNode = textWalker.nextNode())) {
      textNode.nodeValue = textNode.nodeValue
        .replace(/Warum\s+marokkanische\s+Sedari\s*!+/gi, 'Warum ein marokkanischer Sedari?')
        .replace(/Brauchst du Hilfe\?/g, 'Benötigen Sie Hilfe?');
    }
  }

  function initializeThemeCorrections() {
    updatePolicyContent();
    updateVisibleCopy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeThemeCorrections);
  } else {
    initializeThemeCorrections();
  }
})();
